module.exports = __webpack_public_path__ + "static/gallery_16-def423101f7a73c9bb7897c069f17db7.jpg";